
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, computed } from "vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { Serializers } from "sanity-blocks-vue-component/dist/types";
import { imageUrlBuilder } from "@/services/sanity";
import Grid from "@moonlight/vue3/components/Grid.vue";

const serializers: Serializers | { types: Partial<Serializers["types"]> } = {
  styles: {
    blockquote: "blockquote",
    lead: "lead",
  },
  marks: {
    link: (props, content) => {
      return (
        <a {...props} target="_blank">
          {content}
        </a>
      );
    },
    "strike-through": (props, content) => {
      return <s {...props}>{content}</s>;
    },
    code: (props, content) => {
      return <code {...props}>{content}</code>;
    },
  },
  types: {
    image: (props: any) => {
      return (
        <img
          alt={props.altText || ""}
          src={imageUrlBuilder
            .image(props.asset)
            .maxWidth(600)
            .auto("format")
            .url()}
          srcset={
            `${imageUrlBuilder
              .image(props.asset)
              .maxWidth(600)
              .auto("format")
              .url()} 600w, ` +
            `${imageUrlBuilder
              .image(props.asset)
              .maxWidth(1200)
              .auto("format")
              .url()} 1200w`
          }
          class="c-rich-text__image"
        />
      );
    },
  },
};

export default defineComponent({
  components: {
    SanityBlocks,
    Grid,
  },
  props: {
    blocks: {
      type: Array,

      required: true,
    },
    gridSize: {
      type: String,
      default: "lg",
    },
  },
  setup(props) {
    const blocksAndImages = computed<(any[] | any)[]>(() => {
      return props.blocks.reduce((acc: any[], block: any) => {
        if (block._type === "image") {
          return [...acc, block];
        } else {
          const lastIndex = acc.length - 1;

          if (acc[lastIndex]?._type === "image") {
            return [...acc, [block]];
          }

          acc.splice(lastIndex, 1, [...(acc[lastIndex] || []), block]);
          return acc;
        }
      }, []);
    });

    return {
      blocksAndImages,
      serializers,
    };
  },
});
